import classNames from 'classnames';
import type React from 'react';

import './Spinner.scss';

type SpinnerProps = {
  className?: string;
  children?: React.ReactNode;
};

export const Spinner = ({
  children,
  className = 'h-[40vh]',
  ...rest
}: SpinnerProps) => {
  return (
    <div
      className={classNames('Spinner', className)}
      {...rest}
      tabIndex={0}
      data-testid="spinner"
    >
      {children}
    </div>
  );
};
